export class LoadAccountCountriesFromApi {
    public static readonly type: string = '[Accounts API] Load countries';
}
